import { render, staticRenderFns } from "./ObjectInformation.vue?vue&type=template&id=6c1d3070&scoped=true"
import script from "./ObjectInformation.vue?vue&type=script&lang=js"
export * from "./ObjectInformation.vue?vue&type=script&lang=js"
import style0 from "./ObjectInformation.vue?vue&type=style&index=0&id=6c1d3070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1d3070",
  null
  
)

export default component.exports